import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Container, Button, Card, CardContent, Grid } from '@material-ui/core';
import { BarLoader } from 'react-spinners';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PersonalDetails from './PersonalDetails';
import LimitSummary from './LimitSummary';
import Affordability from './Affordability';
import BankingDetails from './BankingDetails';
import Documents from './Documents';
import Address from './Address';
import { useClientContext } from '../../context/client_context';
import ClientNotes from './ClientNotes';
import SubsTransactions from './SubsTransactions';
import ProvidentSubs from './ProvidentTrans';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

export default function ClientPortfolio() {
  const { loadingClient, customerIdentifier } = useClientContext();
  const [heading, setHeading] = useState('Personal Details');
  const [module, setModule] = useState(2);
  const navigate = useNavigate();
  const dept = sessionStorage.getItem('department');

  const createPrescription = (e) => {
    navigate(`/dashboard/createinvoice`);
  };

  const updateClient = () => {
    navigate('/clientportfolio/registerclient/00000000-0000-0000-0000-000000000000');
    // navigate('/clientportfolio/registerclient');
  };

  return (
    <Container>
      {!loadingClient && <BarLoader />}
      {loadingClient && (
        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setHeading('Portfolio');
                    setModule(1);
                  }}
                >
                  Portfolio
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => {
                    setHeading('Personal Details');
                    setModule(2);
                  }}
                >
                  Personal Details
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setHeading('Banking Details');
                    setModule(3);
                  }}
                >
                  Banking Details
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setHeading('Subscriptions');
                    setModule(5);
                  }}
                >
                  Subscriptions
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setHeading('Provident Subs');
                    setModule(9);
                  }}
                >
                  Provident Subs
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  href="#contained-buttons"
                  fullWidth
                  onClick={() => {
                    setHeading('Client Notes');
                    setModule(7);
                  }}
                >
                  Client Notes
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    updateClient();
                    setModule(8);
                  }}
                >
                  Update Profile..
                </Button>
              </Grid>
              {/* <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setHeading('Address');
                    setModule(6);
                  }}
                >
                  Address
                </Button>
              </Grid> */}
              {/* <Grid item xs={12} sm={2}>
                <Button variant="contained" color="primary" disabled fullWidth>
                  Credit Checks
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button variant="contained" disabled fullWidth>
                  Debit Orders
                </Button>
              </Grid> */}
              {/* <Grid item xs={12} sm={2}>
                <Button variant="contained" disabled color="primary" fullWidth>
                  Comms.. History
                </Button>
              </Grid> */}
              <Grid item xs={12} sm={2}>
                {dept === 'pharmacy' && (
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      createPrescription();
                    }}
                  >
                    Prescription
                  </Button>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
      <Typography variant="h4" gutterBottom>
        {heading}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {module === 1 && <LimitSummary />}
          {module === 2 && <PersonalDetails />}
          {module === 3 && <BankingDetails />}
          {module === 4 && <Affordability />}
          {module === 5 && <SubsTransactions />}
          {module === 6 && <Address />}
          {module === 7 && <ClientNotes />}
          {module === 9 && <ProvidentSubs />}
        </Grid>
      </Grid>
      {/* <Stack mb={5}>
        <PersonalDetails />
      </Stack> */}
    </Container>
  );
}
